import { ApiListActionTagsResponse } from '../../../api/core/models';
import { BoardSettingsV2 } from '../model';

export function apiBoardSettingsToActionTags(
  actionTagsResponse?: ApiListActionTagsResponse
): BoardSettingsV2['actionTags'] {
  if (!actionTagsResponse?.ActionTags) {
    return undefined;
  }
  return actionTagsResponse.ActionTags.map((actionTag) => ({
    id: actionTag.id,
    title: actionTag.displayValue,
    colour: actionTag.colour,
  }));
}
